import notification from 'antd/lib/notification';
import { useEffect, useState } from 'react';

import useAutoCredRequestId from '@/components/App/NewOrder/hooks/useAutoCredRequestId';
import { useAppDispatch, useAppSelector } from '@/store';
import {
  onSetSelectedBank,
  setShouldUpdateBankInfo
} from '@/store/financingStep.slice';
import { getEuBankStatus } from '@/store/offerStep.slice';

import useLoadDocuments from '../../../hooks/useLoadDocuments';

const useEurasStatus = () => {
  const dispatch = useAppDispatch();

  const { selectedBank, shouldUpdateBankInfo } = useAppSelector(
    (state) => state.financingStep
  );
  const { banksOffers } = useAppSelector((state) => state.offerStep);

  const { requestId } = useAutoCredRequestId();

  const [updateStatusLoading, setUpdateStatusLoading] = useState(false);

  const { handleLoadEuBankFiles } = useLoadDocuments();

  const handleChangeEuBankStatus = async () => {
    setUpdateStatusLoading(true);
    const data = {
      requestId: requestId,
      responseExtUuid: selectedBank?.extId || ''
    };
    const response = await dispatch(getEuBankStatus(data));
    if (response.payload !== null && response.payload !== undefined) {
      notification.success({
        title: 'Успех',
        description: 'Статусы банка обновлены',
        duration: 5
      });
    } else {
      notification.error({
        title: 'Ошибка',
        description: 'Ошибка обновления статуса',
        duration: 5
      });
    }
    setUpdateStatusLoading(false);
  };

  useEffect(() => {
    if (shouldUpdateBankInfo === 'eu_bank') {
      dispatch(setShouldUpdateBankInfo(''));
      handleLoadEuBankFiles();
    }
  }, [shouldUpdateBankInfo]);

  useEffect(() => {
    if (selectedBank?.bank.name !== 'eu_bank') return;
    const euBank = banksOffers.find((offer) => offer.bank.name === 'eu_bank');
    if (euBank) dispatch(onSetSelectedBank(euBank));
  }, [banksOffers]);

  return { updateStatusLoading, handleChangeEuBankStatus };
};

export default useEurasStatus;
